import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { UsuarioModel } from '../model/Usuario.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: [
    './usuario.component.css',
  ]
})
export class UsuarioComponent implements OnInit {

  public userId: string;
  public form: UntypedFormGroup;
  public usuario: UsuarioModel;
  public roles: string[] = [];
  public imagenASubir: File;
  public imgTemp: any;

  get soyAdmin(): boolean {
    return this.authService.soySuperAdministrador;
  }

  get rolNoValido(): boolean {
    return this.form.get('role').invalid && this.form.get('role').touched;
  }

  get loginNoValido(): boolean {
    return this.form.get('login').invalid && this.form.get('login').touched;
  }

  get activeAccount(): boolean {
    return this.form.get('active').value;
  }

  get id(): string {
    return this.form.get('id').value;
  }

  get diskUsage(): number {
    const quota = Number.parseFloat(this.form.get('disk_mb_quota').value);
    const mb    =  Number.parseFloat(this.form.get('disk_mb_size').value);
    return (quota) ? 100*mb/quota : 0;
  }

  constructor( private fb: UntypedFormBuilder,
               private activatedRouter: ActivatedRoute,
               private router: Router,
               private authService: AuthService ) {
  }

  ngOnInit(): void {
    this.crearFormulario();
    this.activatedRouter.params.subscribe( params => {
      this.userId = params.id;
      this.load();
    });
  }
  
  load(): void {
    this.cargarUsuario( this.userId );
    this.cargaRoles();
  }

  crearFormulario(): void {

    this.form = this.fb.group({
      id          : [''],
      login       : [{ value: '', disabled: !this.soyAdmin }, Validators.required ],
      user_email  : [{ value: '', disabled: !this.soyAdmin }],
      role        : [{ value: '', disabled: !this.soyAdmin }, Validators.required ],
      display_name: [''],
      www         : [''],
      slogan      : [''],
      active      : [{ value: '', disabled: !this.soyAdmin }],
      auth_key    : [''],
      disk_mb_size: [''],
      disk_mb_quota: [{ value: '', disabled: !this.soyAdmin }],
      liveEnabled: [{ value: '', disabled: !this.soyAdmin }],
      live_start_date: [{ value: '', disabled: !this.soyAdmin }],
      live_expiration: [{ value: '', disabled: !this.soyAdmin }],
    });

  }

  enviar(): void {
    if ( this.form.invalid ) {
      console.log('Form inválido ');
      Swal.fire( 'Error de validación', 'El formulario tiene errores', 'error' );
      return;
    }

    if ( !this.form.get('id').value && !this.soyAdmin ) {
      return;
    }

    this.usuario = { img: this.usuario.img, ...this.form.value };

    Swal.fire({
      title: 'Guardando cambios',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.authService.guardaUsuario( this.usuario, this.imagenASubir )
      .subscribe( ( resp: UsuarioModel ) => {

          if ( !this.usuario.id ) {

            this.usuario.id = resp.id;
            this.form.patchValue({ id: resp.id });
            Swal.fire( 'Usuario creado', `Se ha creado el usuario <${resp.id}>` );

          } else {

            Swal.fire( 'Usuario actualizado', `El usuario se ha actualizado correctamente` );

          }
        },
        ( error => {
            Swal.fire( 'Usuario NO actualizado', `Se ha producido un error. ${ error.error.msg }`, 'error' );
        })
      );
  }

  private getInputDateTime( fecha: string ): string {
    if ( fecha ) {
      return fecha.replace( ' ',  'T' );
    } else {
      return null;
    }
  }


  cargaForm(): void {
    const data: any = { ...this.usuario };
    data.active =  this.usuario.status && ( this.usuario.status !== '0' );
    data.liveEnabled = this.usuario.live_enabled && ( this.usuario.live_enabled !== '0' );
    if (!data.active) {
      data.active = '';
    }
    delete data.status;
    delete data.live_enabled;
    delete data.created_on;
    delete data.img;
    delete data.features;
    data.live_start_date = this.getInputDateTime( data.live_start_date );
    data.live_expiration = this.getInputDateTime( data.live_expiration );
    this.form.setValue( data );
  }

  cargaRoles(): void {
    this.authService.getRoles()
      .subscribe( roles => {
        this.roles = this.authService.roles;
      });
  }

  cargarUsuario( login: string ): void {

    if ( !this.soyAdmin && (login != this.authService.loginInfo.userName )) {
      this.router.navigate(['home']);
    }

    this.authService.getUsuario(login)
      .subscribe ( usr => {
        this.usuario = usr;
        // console.log('cargarUsuario => ', usr);
        
        if ( !usr.id ) { // New user, auto generate activation key
          this.usuario.auth_key = this.authService.generateRandom();
          this.usuario.role = 'USER';
        }
        this.cargaForm();
      }
    ,( error => {
        console.error(`Error loading user info for ${login}`);
        this.router.navigate(['home']);
     }));

  }

  regeneraAuth(): void {
    this.form.patchValue({ auth_key: this.authService.generateRandom()} );
  }

  cambiarImagen( fichero: File ) {
    this.imagenASubir = fichero;

    if ( !fichero ) { return this.imgTemp = null; }

    const reader = new FileReader();
    reader.readAsDataURL( fichero );

    reader.onload = () => {
      this.imgTemp = reader.result;
    };
  }


}
